<template>
  <div  style='overflow-y: hidden;
      overflow-x: hidden;'>
    <locationSearch ref="locationSearch" @clicked="changedLocationInput" :prefix="'location.' + treeID" :aggregations="locationFacets" :setLocations="setLocationsLocal" :locationsPreSet="locations">
    </locationSearch>
    <div>
      <v-card-title class="pb-1 mb-2 mx-3" style="border-bottom: 1px dashed #666;">Annotations</v-card-title>
        <v-text-field
          v-model="search"
          label="Search Iconography Tree"
          hide-details
          clearable
          clear-icon="mdi-close-circle-outline"
        >
        </v-text-field>
        <v-treeview
        :item-key="'id'"
        :open.sync="openedLeaves"
        id="annoTree"
        selection-type="leaf"
        :filter="filter"
        :search="search"
        return-object
        v-model="localIcoSelected"
        rounded
        selectable
        hoverable
        :items="treeItems"
        dense
        multiple-active
        :active="icoActivated"
      >
        <template v-if="renderVRMode" v-slot:prepend="{ item }">
        <input
          type="checkbox"

          class="native-checkbox"
          :checked="isItemSelected(item)"
          @change="clickAnno(item)"
        />
      </template>
        <template class="v-treeview-node__label" slot="label" slot-scope="{ item }">
          <a :id="treeID"  @click="clickAnno(item)" @mouseover="mouseOverNode(item)" @mouseleave="mouseLeaveNode(item)">

            <div class="v-treeview-node__label" style="white-space: wrap !important;">
              {{ item.name }}
              <v-badge
                :content="getCount(item)"
                inline
                color="primary"
                ref="badge"
              >
              </v-badge>
            </div>
          </a> <a :href="getIconographyLink(item)">[go to]</a>
        </template>
      </v-treeview>
    </div>
</div>
</template>
<script>
import locationSearch from '@/components/locationSearch.vue'

export default {
  name: 'Cave3DModelFilterPanel',
  components: {
    locationSearch
  },
  props: {
    renderVRMode: {
      type: Boolean,
      default: false
    },
    setLocations:Function,
    locations:{
      type: Array,
      default: function () {
        return []
      },
    },
    updateicoSelectedParent:Function,
    prepLocationAggs: Function,
    changedLocationInput: Function,
    annoPrCount: {
      type: Object,
      default: function () {
        return {}
      },
    },
    locationFacets: {
      type: Array,
      default: function () {
        return []
      },
    },
    search: null,
    treeID: "",
    relatedDepictions: {
      type: Array,
      default: function () {
        return []
      },
    },
    filteredIcoAnnos: {
      type: Array,
      default: () => []
    },
    annoPreSelected: {
      type: Array,
      default: function () {
        return []
      },
    },
    hoveredIcos: {
      type: Array,
      default: function () {
        return []
      },
    }
  },
  data () {

    return {
      annotationsByWall: {},
      cave3DInfForWalls: {},
      icoActivated: [],
      selectedDepictions:[],
      openedLeaves:[],
      localIcoSelected: []
    }
  },
  computed: {
    treeItems() {
      if (!this.filteredIcoAnnos) return [];
      return JSON.parse(JSON.stringify(this.filteredIcoAnnos));
    },
    icoSelected:{
      get: function(){
        return  this.annoPreSelected;
      },
      set: function (newValue){
        if (JSON.stringify(newValue) !== JSON.stringify(this.annoPreSelected)) {
          this.updateicoSelectedParent(newValue)
        }
      }
    },
    filter () {
      return  (item, search, textKey) => {
        if (item.search) {
          // .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          return (item["search"].toLowerCase().normalize("NFD").indexOf(search) > -1 || item["name"].toLowerCase().normalize("NFD").indexOf(search) > -1)
        } else {
          return (item["name"].toLowerCase().normalize("NFD").indexOf(search) > -1)
        }
      }
    },
    iconographyById() {
      return this.indexIconographyTree(this.filteredIcoAnnos)
    }
  },
  methods: {
    indexIconographyTree(nodes, map = new Map()) {
      nodes.forEach(node => {
        if (node?.iconographyID) {
          map.set(node.iconographyID, node)
        }

        if (node.children?.length) {
          this.indexIconographyTree(node.children, map)
        }
      })

      return map
    },

  // Hilfsfunktion: Rekursiv IDs einsammeln
    collectAllIDs(nodes, acc = []) {
      for (const node of nodes) {
        acc.push(node) // oder iconographyID, wenn das deine `item-key` ist
        if (node.children && node.children.length > 0) {
          this.collectAllIDs(node.children, acc)
        }
      }
      return acc
    },
    isItemSelected(item) {
      return this.icoSelected.find(i => i.id === item.id)
    },
    setLocationsLocal(newValue){
      console.log("changed location input!!!!!! filtertree");
      this.setLocations(newValue)
    },

    getCount(item){

      return this.annoPrCount[item.iconographyID]
    },
    prepSearch(){
      this.$refs.locationSearch.prepSearch()
    },
    switchShowTree(){
      this.showTree = !this.showTree
      const _self = this
      setTimeout(function(){ _self.onWindowResize()}, 50);


    },
    getIconographyLink(item){
      return window.location.origin  + "/iconography/" + item.id
    },
    onSelect(selected){
      console.log("onSelect", selected);

      this.updateicoSelectedParent(selected)

    },
    clickAnno(item){
      console.log("click anno");

      let found = false
      let filteredAnnos = []
      for (let anno of this.icoSelected){
        if (anno.id === item.id){
          found = true
        } else {
          filteredAnnos.push(anno)
        }
      }
      if (found) {
        this.icoSelected = filteredAnnos
      } else {
        this.icoSelected.push(item)
      }
    },
    mouseOverNode(item){
      console.log("blubb");


    },
    mouseLeaveNode(item){
    }
  },
  watch: {
    treeItems: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.openedLeaves = this.collectAllIDs(val)
        }
      },
      deep: true
    },
    locations: {
      handler(val){


        this.changedLocationInput()
      },
      deep: true
    },
    annoPreSelected: {
      handler(val){
        console.log("annoPreSelected changed!", val, this.treeID);

        this.localIcoSelected = val
      },
      deep: true
    },

    localIcoSelected: {
      deep: true,
      handler(val) {
        this.updateicoSelectedParent(val)
      }
    },
    annoPrCount: {
      handler(val){
        console.log("annoPrCount changed!");
      },
      deep: true
    },
    openedLeaves: {
      handler(val){
      },
      deep: true
    },
    hoveredIcos: {
      handler(val){
        this.icoActivated = val.map(id => this.iconographyById.get(id)).filter(Boolean)
        this.$log.debug("hoveredIcos changed!", this.icoActivated, val);
      },
      deep: true
    }
  },
  created () {
  },
  beforeDestroyed () {

  },
  beforeMount:function(){

  },
  mounted() {
    this.$log.debug("mounted filterpanel", this.treeID);
  }
}
</script>

<style lang="css" >
  .color-box {
    width: 48px;
    height: 24px;
  }
.fake-checkbox {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border: 1px solid #000;
  background-color: #fff;
  vertical-align: middle;
  position: relative;
}
.fake-checkbox.checked::after {
  content: "✓";
  position: absolute;
  top: -1px;
  left: 2px;
  font-size: 14px;
  color: black;
}
.tree-label {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: normal;
}

.native-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
</style>
